import FullScreenLoader from '$tablet-app/src/app/components/FullScreenLoader';
import Row from '$tablet-app/src/app/components/Row';
import Text from '$tablet-app/src/app/components/Text';
import { getGoalCompletionProgress } from '$tablet-app/src/app/goals/functions';
import { useMyGoals } from '$tablet-app/src/app/goals/useGoals/useGoals';
import { layout, palette } from '$tablet-app/src/app/theme';
import useCurrentDay from '$tablet-app/src/app/utils/useCurrentDay';
import { Goal } from '@akin-home/goals';
import React, { FC } from 'react';
import { ScrollView, View } from 'react-native';
import styled from 'styled-components/native';
import { useIncrementGoal } from '../../goals/hooks/useIncrementGoal';
import { useMainDrawerNavigaton } from '../../navigation/hooks';
import { useCurrentUserID } from '../../users';
import DashboardPanel from '../DashboardPanel';
import DashboardPanelTitle from '../DashboardPanelTitle';

const TodaysGoals: FC = () => {
  const user_id = useCurrentUserID();

  const { data: goals, isLoading } = useMyGoals();

  const { navigate } = useMainDrawerNavigaton();

  const day = useCurrentDay();

  const goalKeyData = {
    user_id,
    date: new Date(day),
  };

  const increment = useIncrementGoal(goalKeyData);

  const onItemPress = (goal: Goal) => () => increment(goal, goalKeyData);

  const goToGoals = () => navigate('Goals');

  return (
    <Panel>
      <DashboardPanelTitle text="TODAY'S GOALS" />

      {isLoading ? (
        <FullScreenLoader />
      ) : goals.length ? (
        <ScrollView>
          {goals.map((goal) => (
            <Item key={goal.id} onPress={onItemPress(goal)}>
              <Row width="100%" alignItems="center">
                {goal.emoji ? <Emoji>{goal.emoji}</Emoji> : null}

                <View style={layout.flex_1}>
                  <Text weight="semibold">{goal.title}</Text>
                </View>

                <View>
                  <Text>
                    {getGoalCompletionProgress(goal, goalKeyData)}/
                    {goal.completions_per_period}
                  </Text>
                </View>
              </Row>
            </Item>
          ))}
        </ScrollView>
      ) : (
        <Placeholder onPress={goToGoals}>
          <Text variant="h3" weight="semibold">
            Press here to create some goals!
          </Text>
        </Placeholder>
      )}
    </Panel>
  );
};

const Panel = styled(DashboardPanel)`
  flex: 1;
  padding: 15px;
`;

const Item = styled.TouchableOpacity`
  background-color: ${palette.Background_blue};
  padding: 10px 5px 10px 15px;
  align-items: center;
  border-radius: 10px;
  margin-bottom: 20px;
  margin-right: 5px;
`;

const Emoji = styled(Text)`
  font-size: 24px;
  margin-right: 10px;
`;

const Placeholder = styled.TouchableOpacity`
  flex: 1;
  align-items: center;
  justify-content: center;
`;

export default TodaysGoals;
